import { PageHeaderCombinedProps } from './types';

const usePresenter = (props: PageHeaderCombinedProps): PageHeaderCombinedProps => {
  return props;
};

export default usePresenter;
